/** @module DataLayerProductImpressionList */

import {
  DataLayerEventProductImpression,
  DataLayerProductImpression,
} from "@/../types/data-layer";
import { DATA_LAYER_EEC_PRODUCT_IMPRESSION_EVENT } from "@/constants";

/**
 * @Class
 * Representation of a product item listing from a user view for use in Google Tag Manager.
 * This data layer event is part of UA Enhanced Ecommerce tracking framework.
 *
 * https://aircanadavacations.atlassian.net/wiki/spaces/AW/pages/2032205961/UA+Product+Impressions+Data+Layer+Event+eec-productImpressions
 */
export class DataLayerProductImpressionList {
  /**
   *
   * @param {Array<DataLayerProductImpression>} impressions
   */
  static create(
    impressions: Array<DataLayerProductImpression>
  ): DataLayerEventProductImpression {
    return {
      event: DATA_LAYER_EEC_PRODUCT_IMPRESSION_EVENT,
      ecommerce: { currencyCode: "CAD", impressions: impressions },
    };
  }
}
